import { useState } from "react";
import { RequestStatus } from "../../common";
import { deleteMaterial } from "@/services/createSpace/material";
import { Message } from "@arco-design/web-react";

interface IUseDeleteMaterialRetrun<T> {
  loading: RequestStatus;
  handleMetarialDelete: (
    ids: string | string[],
    data: T[],
    state: boolean,
  ) => Promise<T[]>;
}

const useDeleteMaterial = <
  T extends { id: string },
>(): IUseDeleteMaterialRetrun<T> => {
  const [loading, setLoading] = useState(RequestStatus.NOTREQUESTED);

  const handleMetarialDelete = async (
    ids: string | string[],
    data: T[],
    state: boolean,
  ) => {
    setLoading(RequestStatus.LOADING);
    const result: any = await deleteMaterial(ids, state);
    console.log(result, 'result')
    if (result?.code === 0) {
      let newData = [...data];
      if (Array.isArray(ids)) {
        newData = data.filter((item) => !ids.includes(item.id));
      } else {
        const index = data.findIndex((item) => item.id === ids);
        newData.splice(index, 1);
      }
      Message.success("删除成功");
      return newData;
    } else {
      Message.error(result?.data.message || "删除失败");
    }
  };

  return {
    loading,
    handleMetarialDelete,
  };
};

export default useDeleteMaterial;
